import { Observable } from "../../utils/reactive.js";
import { UserActionImportance, userActionStart } from "./const.js";
import "./types.js";
import UserAction from "./userAction.js";
//#region src/api/userActions/initialize.ts
const userActionsMessageBus = new Observable();
function initializeUserActionsAPI({ transports, internalLogger, config, pushEvent }) {
	var _config$userActionsIn;
	const trackUserActionsExcludeItem = (_config$userActionsIn = config.userActionsInstrumentation) === null || _config$userActionsIn === void 0 ? void 0 : _config$userActionsIn.excludeItem;
	let activeUserAction;
	const startUserAction = (name, attributes, options) => {
		if (getActiveUserAction() === void 0) {
			const userAction = new UserAction({
				name,
				transports,
				attributes,
				trigger: (options === null || options === void 0 ? void 0 : options.triggerName) || "faroApiCall",
				importance: (options === null || options === void 0 ? void 0 : options.importance) || UserActionImportance.Normal,
				trackUserActionsExcludeItem,
				pushEvent
			});
			userAction.filter((v) => [3, 2].includes(v)).first().subscribe(() => {
				activeUserAction = void 0;
			});
			userActionsMessageBus.notify({
				type: userActionStart,
				userAction,
				initialActivityTimeout: options === null || options === void 0 ? void 0 : options.initialActivityTimeout
			});
			activeUserAction = userAction;
			return activeUserAction;
		} else {
			internalLogger.error("Attempted to create a new user action while one is already running. This is not possible.");
			return;
		}
	};
	const getActiveUserAction = () => {
		return activeUserAction;
	};
	return {
		startUserAction,
		getActiveUserAction
	};
}
/**
* Adds an item to the buffer associated with the given UserAction.
* The item will only be added if the UserAction is in the Started state.
* @param userAction The UserAction instance
* @param item The item to add to the buffer
* @returns {boolean} True if the item was added, false otherwise
*/
function addItemToUserActionBuffer(userAction, item) {
	if (!userAction) return false;
	if ((userAction === null || userAction === void 0 ? void 0 : userAction.getState()) !== 0) return false;
	userAction.addItem(item);
	return true;
}
//#endregion
export { addItemToUserActionBuffer, initializeUserActionsAPI, userActionsMessageBus };

//# sourceMappingURL=initialize.js.map